import api, { isAxiosError } from "./api";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

type ApiErrorBody = {
  message?: string;
  error?: string;
  errors?: Array<{ message?: string }>;
};

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

const getApiErrorMessage = (err: unknown): string | undefined => {
  if (isAxiosError(err)) {
    const response =
      typeof err === "object" && err !== null && "response" in err
        ? (err as any).response
        : undefined;
    const data = response?.data as ApiErrorBody | undefined;
    return data?.message ?? data?.error ?? data?.errors?.[0]?.message;
  }
  if (err && typeof err === "object" && "message" in err) {
    return (err as { message?: string }).message;
  }
  return undefined;
};

export const getUsersAvailable = async (): Promise<null | any> => {
  const userId = localStorage.getItem("@UltragazEmpresarial:userId");

  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };

  try {
    const response = await api.get(
      `/industrial/customer/v1/users/notification?user-id=${userId}&type=MI`,
      {
        headers,
      }
    );

    return response.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const message = getApiErrorMessage(error);
      if (message) {
        toast.error(message);
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  }

  return null;
};

export const putUsersAvailable = async (
  notificationId: string
): Promise<void> => {
  const userId = localStorage.getItem("@UltragazEmpresarial:userId");

  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
  try {
    await api.put(
      `/industrial/customer/v1/users/notification`,
      {
        notificationId,
        userId,
      },
      {
        headers,
      }
    );
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const message = getApiErrorMessage(error);
      if (message) {
        toast.error(message);
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  }
};
